import React from 'react';

import comingSoonImg from '../../images/coming-soon.png';
import styles from './styles/image-comingsoon.scss';

const NonSearchResult = () => 
<div className={styles.nonSearchResult}>
    <img className={styles.nonSearchResultImage} src={comingSoonImg} alt="nonsearch" />
    <p className={styles.nonSearchResultMessage}>Muy pronto tendremos muchos productos en esta área</p>
</div>;

export default NonSearchResult;



/** WEBPACK FOOTER **
 ** ./src/components/product/image-coomingsoon.jsx
 **/